import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { confirmSubscription } from '../lib/api';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

export default function ConfirmPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const confirm = async () => {
      if (!token) {
        setStatus('error');
        setMessage('No confirmation token provided.');
        return;
      }

      try {
        const result = await confirmSubscription(token);
        setStatus('success');
        setMessage(result.message);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'This confirmation link is invalid or has already been used.');
      }
    };

    confirm();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F6] noise-bg p-8">
      <div className="max-w-lg w-full text-center relative z-10 fade-in" data-testid="confirm-page">
        {status === 'loading' && (
          <>
            <div className="w-16 h-16 bg-[#1A2E4A] flex items-center justify-center mx-auto mb-6">
              <Loader2 className="w-8 h-8 text-white animate-spin" />
            </div>
            <h1 className="text-3xl text-[#1A2E4A] mb-4">Confirming...</h1>
            <p className="text-lg text-[#525C6A]">Please wait while we confirm your subscription.</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-[#2E5A44] flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl text-[#1A2E4A] mb-4" data-testid="confirm-success-heading">
              Subscription Confirmed
            </h1>
            <p className="text-lg text-[#525C6A] leading-relaxed mb-8" data-testid="confirm-success-message">
              {message}
            </p>
            <Link 
              to="/"
              className="inline-block bg-[#1A2E4A] hover:bg-[#2B4468] text-white px-8 py-3 font-semibold transition-colors duration-300"
              data-testid="confirm-back-link"
            >
              Back to Digital Law Digest
            </Link>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-[#9B2C2C] flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl text-[#1A2E4A] mb-4" data-testid="confirm-error-heading">
              Confirmation Failed
            </h1>
            <p className="text-lg text-[#525C6A] leading-relaxed mb-8" data-testid="confirm-error-message">
              {message}
            </p>
            <Link 
              to="/"
              className="inline-block bg-[#1A2E4A] hover:bg-[#2B4468] text-white px-8 py-3 font-semibold transition-colors duration-300"
              data-testid="confirm-back-link"
            >
              Back to Digital Law Digest
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
